import { render, staticRenderFns } from "./HotelForm.vue?vue&type=template&id=01c3e531&scoped=true"
import script from "./HotelForm.vue?vue&type=script&lang=js"
export * from "./HotelForm.vue?vue&type=script&lang=js"
import style0 from "./HotelForm.vue?vue&type=style&index=0&id=01c3e531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c3e531",
  null
  
)

export default component.exports